<template>
  <div class="configure-remote-select" ref="content" @click="inputFocus">
    <el-popover
      popper-class="remote-select-popper"
      trigger="click"
      placement="bottom"
      v-model="popoverVisible"
      ref="elPopoverRef"
    >
      <div class="configure-remote-warp" slot="reference">
        <span v-for="item in showValue" :key="item.id" class="show-tag"
          >{{ item.name }}<i class="el-icon-error" @click="delItem(item)"></i>
        </span>
        <input
          :readonly="initLoading"
          v-model="treeFilter"
          @input="inputChange"
          class="search-input"
          placeholder="请输入搜索或选择"
        />
      </div>
      <div class="remote-content" v-if="popoverVisible">
        <div v-loading="initLoading" v-if="initLoading" style="height: 40px; padding: 60px 0"></div>
        <!-- array树 -->
        <template v-if="!treeFilter">
          <div
            class="select-checkbox-li"
            v-for="item in treeList"
            :key="item.id"
            :class="item.check && 'is-pick'"
            :style="{ paddingLeft: `${26 * item.level + 10}px` }"
            v-show="expandShowFilter(item, expandObj)"
            @click="checkItemHandel(item)"
          >
            <div
              class="select-checkbox-li-expand"
              v-if="(item.children || []).length > 0"
              @click.stop="expandHandle(item)"
            >
              <i class="el-icon-caret-bottom" v-show="expandObj[item.id]"></i>
              <i class="el-icon-caret-right" v-show="!expandObj[item.id]"></i>
            </div>
            <div
              v-if="!item.disable"
              :style="{ marginLeft: `${item.children ? 0 : 17}px` }"
              class="select-checkbox-li-icon"
            >
              <i class="el-icon-check icon-gou"></i>
              <!-- <i v-if="item.disable" class="el-icon-minus is-disabled"></i> -->
            </div>
            <div
              v-if="item.disable"
              :style="{ marginLeft: `${item.children ? 0 : 17}px` }"
              class="select-checkbox-li-icon select-checkbox-disabled"
            >
              <!-- <i v-if="item.disable" class="el-icon-minus is-disabled"></i> -->
            </div>
            <div class="select-checkbox-li-text single-ellipsis">{{ item.name }}</div>
            <div
              @click.stop="checkAllHandel(item)"
              :class="[item.checkAll && 'is-pick-all', 'right-check-all']"
              v-if="(item.children || []).length > 0"
            >
              <div class="select-checkbox-li-icon check-all">
                <i class="el-icon-check icon-gou-all"></i>
              </div>
              全选
            </div>
          </div>
        </template>
        <!-- 搜索列表 -->
        <template v-if="treeFilter">
          <p class="filter-tip" v-if="loading">加载中</p>
          <p class="filter-tip" v-else-if="!filterList.length">暂无搜索结果，请重新输入</p>
          <template v-else>
            <div
              class="select-checkbox-li"
              v-for="item in filterList"
              :key="item.id"
              :class="item.check && 'is-pick'"
              @click="checkItemHandel(item)"
            >
              <div class="select-checkbox-li-icon" v-if="!item.disable">
                <i class="el-icon-check icon-gou"></i>
              </div>
              <div class="select-checkbox-li-text single-ellipsis">
                <span v-if="showAllName">{{ item.fullName && item.fullName + ' / ' }}</span
                ><span v-html="item.showName"></span>
              </div>
            </div>
          </template>
        </template>
      </div>
    </el-popover>
  </div>
</template>

<script>
import { services } from '@/service';
import { intersection, cloneDeep, debounce } from 'lodash';
import publicUtilFunc from '@/common/js/publicUtil';
const publicUtil = publicUtilFunc();

const typenameEnum = {
  base_caseType: '案件类型',
  full_procedureType: '审理程序',
  full_base_court: '审理法院',
  fullreason: '案由'
};

export default {
  data() {
    return {
      popoverVisible: false,
      expandObj: {},
      treeList: [],
      value: [],
      hits: {},
      showValue: [],
      showValueList: [],
      initLoading: false,
      loading: false,
      treeFilter: '',
      disableList: [],
      hasChildrenList: [],
      isOnce: true,
      isActive: false,
      filterList: []
    };
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    relationParent: {
      type: [Array, String]
    },
    checkAllName: {
      type: Array,
      default() {
        return ['含下级'];
      }
    },
    showAllName: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    treeList: {
      handler: function() {
        const value = [];
        const showValueList = [];
        const notAdd = [];
        this.treeList.forEach(i => {
          if (i.checkAll && !notAdd.includes(i.id)) {
            notAdd.push(...this.fetchAllChildIds(i.children));
            const allName =
              i.level + 1 > this.checkAllName.length
                ? this.checkAllName[this.checkAllName.length - 1]
                : this.checkAllName[i.level];
            showValueList.push({ id: i.id, name: `${i.name} (${allName})`, children: i.children });
          } else if (i.check && !notAdd.includes(i.id)) {
            showValueList.push({ id: i.id, name: `${i.name}` });
          }
          if (i.check) {
            value.push({ id: i.id, name: `${i.name}` });
          }
        });
        this.value = value;
        this.showValueList = showValueList;
        // if (this.isOnce) {
        //   this.isOnce = false;
        this.valueChange();
        // }
      },
      deep: true
    },
    relationParent() {
      this.$emit('reset');
      this.initValue();
    }
  },
  created() {
    this.inputChange = debounce(this.inputChange.bind(this), 400);
  },
  mounted() {
    this.initLoading = true;
    this.$nextTick(async () => {
      await this.initTreeList();
      this.initValue();
    });
  },
  methods: {
    async inputChange(e) {
      const query = e.target.value;
      this.treeFilter = query;
      const arr = await this.remoteMethod(query);
      const res = arr.map(i => {
        const item = this.treeList.find(o => o.id === i._id);
        item.showName = i.highlight.name[0];
        return item;
      });
      this.filterList = Object.freeze(res);
    },
    async remoteMethod(query) {
      try {
        this.loading = true;
        let options = [];
        if (query !== '') {
          const params = {
            size: 5000,
            highlight: {
              pre_tags: ["<span style='color:red'>"],
              post_tags: ['</span>'],
              fields: {
                name: {
                  boundary_scanner_locale: 'zh_CN',
                  boundary_scanner: 'sentence',
                  type: 'unified',
                  fragmenter: 'span',
                  fragment_size: 5000
                }
              },
              number_of_fragments: 1000
            },
            query: {
              bool: {
                must: [{ term: { 'typename.keyword': typenameEnum[this.type] } }],
                should: [
                  {
                    dis_max: {
                      queries: [
                        {
                          constant_score: {
                            filter: {
                              match_phrase: {
                                name: query
                              }
                            },
                            boost: 6
                          }
                        },
                        {
                          constant_score: {
                            filter: {
                              query_string: {
                                query: this.formatString(query),
                                fields: ['name']
                              }
                            },
                            boost: 4
                          }
                        }
                      ]
                    }
                  }
                ],
                minimum_should_match: 1
              }
            },
            sort: [
              {
                _score: 'desc'
              },
              {
                _script: {
                  script: {
                    source: "doc['name.keyword'].size()>0 ?doc['name.keyword'].value.length():0",
                    lang: 'painless'
                  },
                  type: 'number',
                  order: 'asc'
                }
              }
            ]
          };

          params.query.bool.must_not = [
            {
              term: {
                hide: true
              }
            },
            {
              term: {
                disable: true
              }
            }
          ];

          const { hits } = await services.courseware.getCourseCrime(params);
          options = hits.hits;
        } else {
          options = [];
        }
        return options;
      } catch (err) {
        this.$error(err);
      } finally {
        this.loading = false;
      }
    },
    formatString(input) {
      const formattedString = input.replace(/./g, '"$&"AND').slice(0, -3);
      return `(${formattedString})`;
    },
    popoverControl(e) {
      const isSelf = this.$refs.content && this.$refs.content.contains(e.target);
      if (!isSelf) {
        this.popoverVisible = false;
        document.removeEventListener('click', this.popoverControl);
      }
    },
    inputFocus() {
      this.popoverVisible = true;
      document.addEventListener('click', this.popoverControl);
    },
    treeToArray(tree, options = {}) {
      const { level = 0, fullParentId = '', fullName = '' } = options;
      const arr = [];

      tree.forEach(item => {
        arr.push({
          ...item,
          level,
          fullParentId,
          fullName,
          check: false,
          checkAll: false
        });
        if ((item.children || []).length > 0) {
          const childFullParentId = fullParentId ? [...fullParentId.split('/'), item.id].join('/') : item.id;
          const childFullName = fullName ? [...fullName.split(' / '), item.name].join(' / ') : item.name;
          arr.push(
            ...this.treeToArray(item.children, {
              level: level + 1,
              fullParentId: childFullParentId,
              fullName: childFullName,
              check: false,
              checkAll: false
            })
          );
        }
      });
      return arr;
    },
    checkAllHandel(item) {
      if (!item.disable) {
        item.check = !item.checkAll;
      }
      item.checkAll = !item.checkAll;
      const ids = [item.id, ...this.fetchAllChildIds(item.children)];
      this.setCheckState(ids, item.checkAll);

      setTimeout(() => {
        this.setCheckAll();
      });
    },
    setCheckState(ids, type) {
      this.treeList.forEach(i => {
        if (ids.includes(i.id) && i.check != type) {
          i.check = type;
        }
      });
    },
    checkItemHandel(item) {
      if (item.disable && item.children) {
        // 如果非选项且有子集，展开下级 （案由）
        return this.expandHandle(item);
      }
      // 审理程序 和 地域及法院 选中一级默认给他全选
      if (['full_procedureType', 'full_base_court'].includes(this.type) && item.level === 0 && item.children) {
        if (!item.checkAll && item.check) {
          item.checkAll = item.check;
        }
        this.checkAllHandel(item);
      } else {
        item.check = !item.check;
        setTimeout(() => {
          this.setCheckAll();
        });
      }
    },
    initValue() {
      this.value = [...this.item.value];

      this.setTreeList();
    },
    expandShowFilter(item, expandObj) {
      if (item.level === 0) {
        return true;
      }
      const parentIdArr = item.fullParentId.split('/');
      const parentExpandIsHide = parentIdArr.some(id => !expandObj[id]);
      return !parentExpandIsHide;
    },
    expandHandle(item) {
      if (item.id in this.expandObj) {
        this.expandObj[item.id] = !this.expandObj[item.id];
      } else {
        this.$set(this.expandObj, item.id, true);
      }
    },
    valueChange() {
      setTimeout(() => {
        this.showValue = this.showValueList;
        this.$emit('valueChange', this.item, this.value, this.showValue);
        this.$refs.elPopoverRef && this.$refs.elPopoverRef.updatePopper();
      }, 200);
    },
    delItem(item) {
      const removeList = [item.id, ...this.fetchAllChildIds(item.children)];
      // 初始化check
      this.treeList.forEach(i => {
        if (removeList.includes(i.id)) {
          i.check = false;
          if (i.children) {
            i.checkAll = false;
          }
        }
      });

      this.$nextTick(() => {
        this.valueChange();
      });
    },
    fetchIdx(o, value) {
      return value.findIndex(item => item.id === o.id);
    },
    fetchIdxAll(o, value) {
      const vList = value.map(v => v.id);
      const cList = this.fetchAllChildIds(o.children).filter(i => !this.disableList.includes(i));
      if (!o.disable) {
        cList.push(o.id);
      }
      const fList = cList.filter(i => vList.includes(i));

      return intersection(vList, fList).length === cList.length && cList.length > 0;
    },
    fetchAllChildIds(children = []) {
      const list = [...children];
      const ids = [];
      for (let i = 0; i < list.length; i++) {
        (list[i].children || []).forEach(o => {
          list.push(o);
        });
        ids.push(list[i].id);
      }
      return ids;
    },
    async initTreeList() {
      try {
        const params = {
          size: 5000,
          query: {
            bool: {
              must: [{ term: { 'typename.keyword': typenameEnum[this.type] } }]
            }
          },
          sort: [
            {
              sort: 'desc'
            },
            {
              _id: 'asc'
            }
          ]
        };

        if (['fullreason'].includes(this.type)) {
          params.query.bool.must_not = [
            {
              term: {
                hide: true
              }
            }
          ];
        }

        const { hits } = await services.courseware.getCourseCrime(params);
        this.hits = Object.freeze(hits);

        // this.setTreeList();
      } catch (err) {
        this.$error(err);
      }
    },

    setTreeList() {
      const hits = cloneDeep(this.hits);
      if (this.type === 'full_procedureType' && this.relationParent) {
        hits.hits = hits.hits.filter(o => {
          return intersection(o._source.caseType || [], [this.relationParent]).length > 0;
        });
      }
      // if (this.type === 'full_base_court' && this.relationParent.length) {
      //   hits.hits = this.baseCourtHandel(hits);
      // }
      hits.hits = hits.hits.map(o => {
        return { id: o._id, parentId: o._source.parentId, name: o._source.name, disable: o._source.disable };
      });
      const treeData = publicUtil.arrayToTree(hits.hits);
      const treeList = this.treeToArray(treeData);
      // 初始化check
      const disableList = [];
      const hasChildrenList = [];
      for (let i = 0; i < treeList.length; i++) {
        const curItem = treeList[i];
        curItem.disable && disableList.push(curItem.id);
        curItem.children && hasChildrenList.push(curItem);
        curItem.check = this.fetchIdx(curItem, this.value) !== -1;
      }
      this.disableList = disableList;
      this.hasChildrenList = hasChildrenList;
      this.setCheckAll();
      this.treeList = treeList;
      this.initLoading = false;
    },
    setCheckAll() {
      const hasChildrenList = this.hasChildrenList;
      for (let i = 0; i < hasChildrenList.length; i++) {
        hasChildrenList[i].checkAll = this.fetchIdxAll(hasChildrenList[i], this.value);
      }
    },
    baseCourtHandel(hits) {
      return hits.hits.filter(o => {
        if (o._source.level === 1) {
          o._source.courtLevel = ['最高人民法院', '高级人民法院', '中级人民法院', '基层人民法院'];
        } else if (o._source.level === 2) {
          o._source.courtLevel = ['高级人民法院', '中级人民法院', '基层人民法院'];
        } else if (o._source.level === 3) {
          o._source.courtLevel = ['中级人民法院', '基层人民法院'];
        } else if (o._source.level === 4) {
          o._source.courtLevel = ['基层人民法院'];
        }
        if (this.relationParent.includes('基层人民法院')) {
          console.log('');
        } else if (this.relationParent.includes('中级人民法院')) {
          if (o._source.level === 4) {
            o._source.courtLevel = [];
          }
        } else if (this.relationParent.includes('高级人民法院')) {
          if (o._source.level === 3) {
            o._source.courtLevel = [];
          } else if (o._source.level === 4) {
            o._source.courtLevel = [];
          }
        } else if (this.relationParent.includes('最高人民法院')) {
          if (o._source.name !== '最高人民法院') {
            o._source.courtLevel = [];
          }
          if (o._source.level === 2) {
            o._source.courtLevel = [];
          } else if (o._source.level === 3) {
            o._source.courtLevel = [];
          } else if (o._source.level === 4) {
            o._source.courtLevel = [];
          }
        }

        if (!this.relationParent.includes('最高人民法院')) {
          if (o._source.name === '最高人民法院') {
            o._source.courtLevel = [];
          }
        }

        if (this.relationParent.length > 0) {
          if (o._source.level === 1 && o._source.name !== '最高人民法院') {
            o._source.disable = true;
          }
        }

        if (!this.relationParent.includes('高级人民法院')) {
          if (o._source.level === 2) {
            o._source.disable = true;
          }
        }
        if (!this.relationParent.includes('中级人民法院')) {
          if (o._source.level === 3) {
            o._source.disable = true;
          }
        }
        if (!this.relationParent.includes('基层人民法院')) {
          if (o._source.level === 4) {
            o._source.disable = true;
          }
        }

        return intersection(o._source.courtLevel, this.relationParent).length > 0;
      });
    }
  }
};
</script>

<style lang="less" scoped>
.configure-remote-select {
  position: relative;
  width: 100%;
  display: inline-block;
  box-sizing: border-box;

  .el-select {
    width: 100%;
  }

  .configure-remote-warp {
    border: 1px solid #d7dae2;
    border-radius: 4px;
    min-height: 40px;
    max-height: 150px;
    overflow-y: scroll;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding: 4px 0;
    padding-right: 4px;

    &::-webkit-scrollbar {
      display: none;
    }

    .search-input {
      color: #55575b;
      font-size: 14px;
      flex: 1;
      min-width: 120px;
      margin-left: 15px;
      height: 28px;
    }

    .show-tag {
      color: #222222;
      border-radius: 4px;
      font-size: 12px;
      background: #e2e2e2;
      height: 22px;
      line-height: 22px;
      padding: 0 8px;
      white-space: nowrap;
      box-sizing: border-box;
      margin: 2px 0 2px 6px;

      i {
        font-size: 15px;
        color: #b8bcc5;
        margin-left: 4px;
        position: relative;
        top: 2px;
        &:hover {
          cursor: pointer;
          color: #999999;
        }
      }
    }
  }
}

.remote-content {
  box-sizing: border-box;
  // position: absolute;
  background-color: #fff;
  // border: 1px solid #ccd2df;
  z-index: 100;
  width: 100%;
  max-height: 200px;
  overflow: scroll;

  &::-webkit-scrollbar {
    display: none;
  }

  .select-checkbox-li {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #172237;
    cursor: pointer;
    padding: 6px 10px;

    .select-checkbox-li-expand {
      padding-right: 5px;
      font-size: 12px;
      color: #4e555b;
    }

    .select-checkbox-li-text {
      color: #585a5c;
      font-size: 14px;
      line-height: 22px;
      flex: 1;
      width: 0;
    }

    .select-checkbox-li-icon {
      box-sizing: border-box;
      width: 18px;
      height: 18px;
      text-align: center;
      border: 1px solid #dbdfe9;
      border-radius: 2px;
      transition-duration: 0.5;
      margin-right: 5px;

      .icon-gou {
        font-size: 16px;
        color: #fff;
      }

      .is-disabled {
        background: #dbdfe9;
        border: 1px solid #dbdfe9;
        color: #fff;
        cursor: not-allowed;
        // visibility: hidden;
      }

      // &:hover {
      //   border: 1px solid #c8c6c6;
      // }
    }

    .select-checkbox-disabled {
      border: none;
    }

    &.is-pick {
      .icon-gou {
        color: green;
      }
    }

    .icon-gou-all {
      font-size: 16px;
      color: #fff;
    }

    .is-pick-all {
      .icon-gou-all {
        color: green;
      }
    }
  }

  .select-checkbox-li:hover {
    background-color: #f4f6f9;
  }
}

.filter-tip {
  padding: 10px 0;
  margin: 0;
  text-align: center;
  color: #999;
  font-size: 14px;
}

.right-check-all {
  width: 52px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
</style>

<style>
.remote-select-popper {
  width: 500px !important;
  padding: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configureRemoteSelect.vue